module.exports = __webpack_public_path__ + "img/开关D3.7a3987f0.png";